<!-- Login page: full-screen, no nav -->
<div *ngIf="isLoginPage" class="min-h-screen">
  <router-outlet></router-outlet>
</div>

<!-- Portal layout: top nav + content -->
<div *ngIf="!isLoginPage" class="portal-layout">
  <!-- Top Navigation -->
  <header class="topnav">
    <div class="topnav-inner">
      <!-- Logo -->
      <a routerLink="/" class="nav-logo">
        <img
          src="hypenation-black.svg"
          alt="Hypenation"
          class="logo-img"
          width="140"
          height="32"
        />
      </a>

      <!-- Desktop nav links -->
      <nav class="nav-links" aria-label="Main navigation">
        <a
          *ngFor="let item of navItems"
          [routerLink]="item.route"
          class="nav-item"
          [class.active]="isActive(item)"
          [attr.aria-current]="isActive(item) ? 'page' : null"
        >
          <i nz-icon [nzType]="item.icon" aria-hidden="true"></i>
          <span>{{ item.label }}</span>
        </a>
      </nav>

      <!-- Right side: Cart + User -->
      <div class="nav-right">
        <!-- Cart icon -->
        <button
          type="button"
          class="cart-btn"
          (click)="navigateToCart()"
          aria-label="Shopping cart"
        >
          <nz-badge
            [nzCount]="numberOfItems"
            [nzOverflowCount]="99"
            nzSize="small"
          >
            <i nz-icon nzType="shopping-cart" aria-hidden="true"></i>
          </nz-badge>
        </button>

        <!-- User info + Logout -->
        <div class="user-section" *ngIf="userEmail">
          <div class="user-avatar-btn" [title]="userEmail">
            {{ userInitials }}
          </div>
          <button type="button" class="logout-btn" (click)="logout()">
            <i nz-icon nzType="logout" aria-hidden="true"></i>
            <span class="logout-label">Sign Out</span>
          </button>
        </div>

        <!-- Mobile hamburger -->
        <button
          type="button"
          class="mobile-toggle"
          (click)="toggleMobileSidebar()"
          aria-label="Open menu"
        >
          <i nz-icon nzType="menu" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </header>

  <!-- Mobile drawer -->
  <div
    class="mobile-overlay"
    [class.open]="mobileSidebarOpen"
    (click)="toggleMobileSidebar()"
  ></div>
  <div class="mobile-drawer" [class.open]="mobileSidebarOpen">
    <div class="drawer-header">
      <img
        src="hypenation-black.svg"
        alt="Hypenation"
        class="logo-img"
        width="120"
        height="28"
      />
      <button
        type="button"
        class="drawer-close"
        (click)="toggleMobileSidebar()"
        aria-label="Close menu"
      >
        <i nz-icon nzType="close" aria-hidden="true"></i>
      </button>
    </div>
    <nav class="drawer-nav">
      <a
        *ngFor="let item of navItems"
        [routerLink]="item.route"
        class="drawer-link"
        [class.active]="isActive(item)"
        (click)="mobileSidebarOpen = false"
      >
        <i nz-icon [nzType]="item.icon" aria-hidden="true"></i>
        {{ item.label }}
      </a>
      <div class="drawer-divider"></div>
      <button
        type="button"
        class="drawer-link"
        (click)="navigateToCart(); mobileSidebarOpen = false"
      >
        <i nz-icon nzType="shopping-cart" aria-hidden="true"></i>
        Cart
        <span class="drawer-cart-badge" *ngIf="numberOfItems > 0">{{
          numberOfItems
        }}</span>
      </button>
    </nav>
    <div class="drawer-footer" *ngIf="userEmail">
      <p class="drawer-email">{{ userEmail }}</p>
      <button type="button" class="drawer-logout" (click)="logout()">
        Sign Out
      </button>
    </div>
  </div>

  <!-- Main content -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
